import { toast } from 'react-toastify';

export const handleError = (error, customMessage) => {
  let message = customMessage || "Ocurrió un error inesperado.";

  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.error("API Error Data:", error.response.data);
    console.error("Status:", error.response.status);
    
    if (error.response.data && error.response.data.detail) {
      const detail = error.response.data.detail;
      if (Array.isArray(detail)) {
        // Handle Pydantic validation errors
        const validationErrors = detail.map(err => {
          const field = err.loc ? err.loc.join(' -> ') : 'Unknown field';
          return `${field}: ${err.msg}`;
        }).join('\n');
        console.error("Validation Errors:", validationErrors);
        message = `Error de validación:\n${validationErrors}`;
      } else {
        message = typeof detail === 'string' ? detail : JSON.stringify(detail);
      }
    } else if (error.response.status === 401) {
      message = "No autorizado. Por favor, inicia sesión de nuevo.";
    } else if (error.response.status === 403) {
      message = "No tienes permisos para realizar esta acción.";
    } else if (error.response.status === 404) {
      message = "Recurso no encontrado.";
    } else if (error.response.status >= 500) {
      message = "Error interno del servidor. Por favor, inténtalo de nuevo más tarde.";
    }
  } else if (error.request) {
    // The request was made but no response was received
    console.error("Network Error:", error.request);
    message = "Error de red. Por favor, verifica tu conexión a internet.";
  } else {
    // Something happened in setting up the request that triggered an Error
    console.error("Error:", error.message);
  }

  toast.error(message.length > 200 ? message.substring(0, 200) + '...' : message);
};